import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer */}
        <div className="py-8 sm:py-12 grid grid-cols-2 sm:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <div className="text-lg font-bold text-white mb-1">
              Community<span className="text-emerald-500">Guard</span>
              <span className="text-[10px] ml-0.5 font-medium text-slate-500 align-top">API</span>
            </div>
            <p className="text-xs text-slate-500 leading-relaxed max-w-[200px]">
              Structured access to public registry data via a simple REST API.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-3">Product</h4>
            <ul className="space-y-2">
              <li><Link to="/api-docs" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">API Docs</Link></li>
              <li><Link to="/pricing" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">Pricing</Link></li>
              <li><Link to="/search" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">Search</Link></li>
              <li><Link to="/signup" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">Get API Key</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-3">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">About</Link></li>
              <li>
                <a href="mailto:support@communityguardapi.com" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-3">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/disclaimer" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">Data Disclaimer</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-600">
            &copy; {currentYear} CommunityGuardAPI. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">
            Powered by{' '}
            <a
              href="https://asan.digital"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-emerald-400 transition-colors"
            >
              Asan Digital LLC
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
